import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { toRem } from 'design';

export const ButtonIsLoading = styled(Skeleton)`
  && {
    width: ${toRem(71)};
    height: ${toRem(33)};
    border-radius: ${toRem(16.5)};
  }
`;
